// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"c0390913","223":"7ae21739"}[chunkId] + ".chunk.js";
};